const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');

module.exports = class ShortTextCriteria extends Builder {
    constructor(title, properties) {
        super('workflowCriteriaElement_IntegerCriteria', title, properties);
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
